// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1bcRM","header":"Messages_header__ostz0"};